import React, { Component } from "react";
import { Row, Card, CardTitle } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";
import { AxiosPublicAPI, AxiosAPI, getGroupID, getUserID } from '../../helpers/AxiosAPI';
import { putAPi_Accept_Invitation } from '../../constants/APIs';
import { Colxx } from "../../components/common/CustomBootstrap";
import queryString from 'query-string'

class Invitations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
        };
    }
    componentDidMount() {
        console.log(this.props);
        localStorage.setItem("Invitation", "true");
        const values = queryString.parse(this.props.location.search);
        if (this.props.propertyId !== undefined && this.props.groupId !== undefined) {
            let data = { data: values.data, type: 'Login', groupId: this.props.groupId, propertyId: this.props.propertyId };
            console.log(data);
            AxiosPublicAPI({
                method: 'put',
                url: `${putAPi_Accept_Invitation}`,
                data: data
            }).then(
                res => {
                    console.log(res.data);
                    this.setState({ success: true });
                    localStorage.removeItem('Invitation');
                    localStorage.setItem("Invitation", res.data.status);
                    window.location.href = '/app/pages/vouchers';
                },
                error => {
                    console.log('eee.data', error.data);
                    window.location.href = '/app/pages/vouchers';
                }
            );
        } else {
            window.location.href = '/app/pages/vouchers';
        }
    }

    render() {
        return (
            <Row className="h-100">
            </Row>
        );
    }
}
const mapStateToProps = ({ authUser, settings }) => {
    const { user, loading } = authUser;
    const { propertyId, groupId } = settings;
    return { user, loading, propertyId, groupId };
};

export default connect(
    mapStateToProps,
    {
        registerUser
    }
)(Invitations);
